import '../../assets/css/not-found.css';

const ComingSoonComponent = () => (
  <section className='page_404'>
    <div className='container'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='text-center'>
            <div className='four_zero_four_bg'>
              <h1 className='text-center'>Coming Soon</h1>
            </div>

            <div className='contant_box_404'>
              <h3 className='h2' style={{ marginBottom: 50 }}>
                The page you are looking for will be avaible soon!
              </h3>

              {/* <p>the page you are looking for will be avaible soon!</p> */}

              <a href='/' className='link_404'>
                Go Home
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default ComingSoonComponent
